import { WalletBase as n, WalletEvents as a } from "../types/index.mjs";
class h extends n {
  // @ts-expect-error, it is temporarily being ignored
  connected;
  address;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ethereum;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accountChangedCallback;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chainChangedCallback;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor({ type: e, provider: t }) {
    super(), this.ethereum = t;
  }
  isSupported() {
    return !0;
  }
  isConnected() {
    return this.connected;
  }
  getAddress() {
    return this.address;
  }
  install() {
  }
  // @ts-expect-error, it is temporarily being ignored
  setOnAccountChangedCallback(e) {
    this.accountChangedCallback = e;
  }
  // @ts-expect-error, it is temporarily being ignored
  setOnChainChangedCallback(e) {
    this.chainChangedCallback = e;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenerCallback(e, t) {
    switch (e) {
      case a.accountsChanged: {
        this.accountChangedCallback != null && this.accountChangedCallback(t[0]);
        break;
      }
      case a.chainChanged: {
        this.chainChangedCallback != null && this.chainChangedCallback(t[0]);
        break;
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async connect() {
    if (!this.isSupported())
      this.install();
    else
      return this.ethereum.removeAllListeners(), [
        a.accountsChanged,
        a.chainChanged,
        a.connect,
        a.disconnect,
        a.message
      ].forEach((e) => {
        this.ethereum.on(e, (t) => {
          this.listenerCallback(e, t);
        });
      }), this.address = await window.ethereum?.request({ method: "eth_requestAccounts" }).then((e) => e?.[0]), this.connected = !0, this.address;
  }
  disconnect() {
    this.address = void 0, this.accountChangedCallback = void 0, this.connected = !1;
  }
  // Send a generic transaction using MetaMask. The data parameter needs to be encoded with ABI for contract method.
  // params {from ,to ,data}
  // @ts-expect-error, it is temporarily being ignored
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async sendTx(e) {
    return await this.ethereum.request({
      method: "eth_sendTransaction",
      params: [e]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    });
  }
  // Currently has a bug and cannot wait for user selection: https://github.com/MetaMask/metamask-extension/issues/12416
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async addToken(e) {
    return await "";
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  async switchChain(e) {
    return await !1;
  }
}
export {
  h as default
};
//# sourceMappingURL=walletConnect.mjs.map
